import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";

export type customerReportResponse = {
    customerReport: {
        count: number,
        rows: {
            customerId: number,
            customerName: string,
            email: string,
            phoneNumber: string,
            customerType: string,
            order: {
                date: string,
                orderCount: number,
                totalSales: number,
                totalDiscount: number,
                netSales: number,
                returnedOrCancelledOrders: number
            }[],
            refund: {
                date: string,
                refundAmount: number
            }[],
            totalOrderCount: number,
            totalReturnedOrCancelled: number,
            totalSales: number,
            totalDiscount: number,
            totalNetSales: number,
            totalRefund: number
        }[]
    },
    statusCode: string,
    message: string,
    success: boolean
};
export type customerData = {
    customerId: number,
    customerName: string,
    email: string,
    phoneNumber: string,
    customerType: string,
    order: {
        date: string,
        orderCount: number,
        totalSales: number,
        totalDiscount: number,
        netSales: number,
        returnedOrCancelledOrders: number
    }[],
    refund: {
        date: string,
        refundAmount: number
    }[],
    totalOrderCount: number,
    totalReturnedOrCancelled: number,
    totalSales: number,
    totalDiscount: number,
    totalNetSales: number,
    totalRefund: number
}

interface intstate {
    getAllCustomerReport: { loading: boolean, offset: number, value: customerReportResponse | null, error: string, isReached: boolean }
    customerReportData: { loading: boolean, count: number, value: customerData[], error: string | null, filter: string | null }
}

const initialState: intstate =
{
    getAllCustomerReport: { loading: false, offset: 0, value: null, error: '', isReached: false },
    customerReportData: { loading: false, count: 0, value: [], error: null, filter: null }
}

export const getAllCustomerReport = createAsyncThunk('customerReport/getAll', ({ data }: { data: { limit: number, offset: number, filterData: string, locationId: number } }) => {
    let Url = HttpRoutingService.replaceUrl(API.customerReport, { storeId: config.storeId })
    return HttpRoutingService.getMethod<customerReportResponse>(Url, data)
})

const customerReportSlice = createSlice({
    initialState,
    name: "customerReport",
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getAllCustomerReport.pending, (state, action) => {
                state.customerReportData.loading = true
            })
            .addCase(getAllCustomerReport.fulfilled, (state, action) => {
                let offset = action.meta.arg.data.offset || 0;
                let rows = action?.payload?.customerReport?.rows || [];
                if (offset > 0) {
                    state.customerReportData.value = [...state.customerReportData.value, ...rows]
                }
                else {
                    state.customerReportData.value = rows
                }
                state.customerReportData.count = action?.payload?.customerReport?.count
                state.customerReportData.filter = action.meta.arg.data.filterData;
                state.customerReportData.loading = false;

            })
            .addCase(getAllCustomerReport.rejected, (state, action) => {
                state.customerReportData.loading = false
                state.customerReportData.error = action.error.message as string
            })
    }
})

export default customerReportSlice?.reducer